import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Stack,
    TextField,
    Tooltip,
    Typography,
    FormControl,
    RadioGroup,
    Radio,
} from "@mui/material";
import { advancePhase } from "../ProjectActions";
import { useDispatch } from "react-redux";

export default function SegmentsSelect({ project, design, open, onClose }) {
    const dispatch = useDispatch();
    const [phase, setPhase] = useState(0);
    const [customPhaseName, setCustomPhaseName] = useState("");

    const handleSaveAndContinue = () => {
        const phase_name = phase == 0 ? "Verkenningsfase" : phase == 1 ? "Planuitwerkingsfase" : customPhaseName;

        // advancePhase(project.id, segments, design, phase, phase_name, dispatch);
        advancePhase(project.id, phase, phase_name, dispatch);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} scroll="paper" sx={{ verticalAlign: "top", height: "100%" }}>
            <DialogTitle>Nieuwe fase</DialogTitle>
            <DialogContent>
                <Stack >
                    {design && (
                        <Tooltip title={design.description}>
                            <Typography>In de volgende fase wordt het volgende ontwerp meegenomen: {design.name}</Typography>
                        </Tooltip>
                    ) }
                    <FormControl>
                        Selecteer een naam voor de fase, of voer zelf een optie in.
                        <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="0"
                            name="radio-buttons-group"
                            onChange={(event) => {
                                setPhase(event.target.value);
                            }}
                        >
                            <FormControlLabel value="0" control={<Radio />} label="Verkenningsfase" />
                            <FormControlLabel value="1" control={<Radio />} label="Planuitwerkingsfase" />
                            <FormControlLabel value="2" control={<Radio />} label="Anders"></FormControlLabel>
                            {phase == 2 ? (
                                <TextField
                                    value={customPhaseName}
                                    onChange={(event) => {
                                        setCustomPhaseName(event.target.value);
                                    }}
                                    placeholder="Naam van de fase"
                                />
                            ) : (
                                ""
                            )}
                        </RadioGroup>
                    </FormControl>

                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button onClick={handleSaveAndContinue}>
                    Opslaan en volgende fase
                </Button>
            </DialogActions>
        </Dialog>
    );
}
